import styled from "styled-components";

const Body = styled.div`
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-smooth: never;
`;

const S = {
  Body,
};

export default S;
